

export default function numDaysAvailableColumn() {
    return {
        name: 'numDaysAvailable',
        label: 'Num Days Available',
        options: {
            setCellProps: () => ({ sx: { textAlign: 'center' } })
        }
    }
}